import PropTypes from 'prop-types';
import React from 'react';
import { Badge } from '@opendate-app/setlist';
import DealSideRow from './DealSideRow';
import { getStatusConfig, formatAmount, formatCloseDate, formatProbability } from '../../Deals/components/dealStages';

function DealPipelineDetailsCard({ deal }) {
  const statusConfig = getStatusConfig(deal.status);
  const nextAction = [deal.next_action, deal.next_action_on && formatCloseDate(deal.next_action_on)].filter(Boolean).join(' · ');

  return (
    <div className="deal-side-card">
      <div className="deal-side-card-title">Pipeline</div>
      <DealSideRow label="Status" value={deal.status ? <Badge color={statusConfig.color} dot>{statusConfig.label}</Badge> : null} />
      <DealSideRow label="Probability" value={formatProbability(deal.probability)} />
      <DealSideRow label="Weighted amount" value={formatAmount(deal.weighted_amount)} />
      <DealSideRow label="Committed amount" value={formatAmount(deal.committed_amount)} />
      <DealSideRow label="Next action" value={nextAction} />
      {deal.deal_type === 'fundraising' && <DealSideRow label="Fund" value={deal.fund_name} />}
    </div>
  );
}

DealPipelineDetailsCard.propTypes = {
  deal: PropTypes.shape({
    deal_type: PropTypes.string,
    status: PropTypes.string,
    probability: PropTypes.number,
    weighted_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    committed_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    next_action: PropTypes.string,
    next_action_on: PropTypes.string,
    fund_name: PropTypes.string,
  }).isRequired,
};

export default DealPipelineDetailsCard;
